/**
 * §8.12 Community — 5 planned pillars, presented as a future
 * initiative (not launched yet).
 */

import React from 'react'
import {
  Megaphone, MessageSquare, Lightbulb, BadgeCheck, Star, Sparkles, Users, ArrowRight,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import { COMMUNITY_PILLARS } from '../data'
import { TONE } from '../_shared'

const ICONS = { Megaphone, MessageSquare, Lightbulb, BadgeCheck, Star }

export default function Community() {
  return (
    <section id="community" className="relative py-24 md:py-28 scroll-mt-24">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow tone="green">Community</Eyebrow>
          <SectionHeading align="center"
            title={<>A community for{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">operators, by operators.</span></>}
            subtitle="Kalki Ai Cloud Community is a future initiative.  Below is a preview of the five pillars we&apos;re designing around the operators, educators and builders on the platform."
          />
        </div>

        <div className="rounded-2xl border border-amber-400/25 bg-amber-400/[0.05] px-5 md:px-6 py-4 backdrop-blur-xl flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-4">
          <Users className="h-4 w-4 text-amber-400 shrink-0" />
          <p className="text-sm text-zinc-100 leading-relaxed">
            <span className="font-semibold text-white">Community launches in 2026.</span>{' '}
            Interested in early access, moderator roles or being an inaugural contributor? Reach out via <a href="#support" className="font-semibold text-amber-400 hover:brightness-125 inline-flex items-center gap-1">Support <ArrowRight className="h-3 w-3" /></a>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-4">
          {COMMUNITY_PILLARS.map((p) => {
            const tone = TONE[p.tone] || TONE.orange
            const Icon = ICONS[p.iconKey] || Sparkles
            return (
              <div key={p.id} className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl overflow-hidden flex flex-col gap-3">
                <div className="pointer-events-none absolute inset-0 opacity-40"
                  style={{ background: `radial-gradient(80% 40% at 20% 0%, rgba(${tone.rgb},0.10), transparent 70%)` }} />
                <div className="relative flex items-center justify-between">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border"
                    style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.08)`, color: tone.hex }}>
                    <Icon strokeWidth={1.8} style={{ width: 17, height: 17 }} />
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/[0.03] px-2 py-0.5 text-[9.5px] font-mono uppercase tracking-wider text-zinc-500">planned</span>
                </div>
                <div className="relative">
                  <h4 className="text-[14px] font-semibold text-white leading-tight">{p.label}</h4>
                  <p className="text-[12px] text-zinc-400 leading-relaxed mt-1.5">{p.body}</p>
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
